export type ContactDraft = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
};

/** The value a code was last sent to, per channel. Absent until the user changes that field. */
export type CodeSentTo = {
  email?: string;
  phoneNumber?: string;
};

/** Instructions the user typed, keyed by user group address id. Untouched addresses are absent. */
export type InstructionsDraft = Record<number, string>;

/**
 * Shared by every mutation this flow owns, so the dialogs can wait for their own
 * requests without a global `useIsMutating()` that any unrelated mutation in the
 * customer app would trip.
 */
export const PERSONAL_INFO_REVIEW_MUTATION_KEY = ['personal-info-review'] as const;
